import React from 'react'
import chbottle from "../assets/images/chbottle.svg"
import lungslogo from "../assets/images/lungslogo.svg"
import boostimmune from "../assets/images/boostimmune.svg"
import bones from "../assets/images/bones.svg"
import energy from "../assets/images/energy.svg"
import formulations from "../assets/images/four powerful formulations.svg"


const VitalityBoxx = () => {
  return (
         <div className="relative md:bottom-[100px] bottom-[0px]">
          <svg
            className="absolute inset-0 w-full h-full"
            viewBox="0 0 1440 1892"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              d="M0 42.35C575.38 -12.7346 891.319 -15.482 1440 42.35V1892C877.655 1798.63 562.346 1798.7 0 1892V42.35Z"
              fill="#EFF6FF"
            />
          </svg>
          <div className="second-bg-from-gray-skew bg-no-repeat bg-none md:bg-[url('https://cdn.blackincae.com/pKU-lab-l-otto.png')] md:bg-[length:600px] md:bg-[position:right_95%]">
            <p className="md:pt-0 pt-8 text-[#204058] font-normal text-[24px] text-center mx-auto max-w-2xl uppercase">
              Introducing
            </p>
            <p className="mb-6 text-[#204058] font-bold text-[48px] text-center mx-auto max-w-2xl italic underline bold-font">
              The Vitality Box
            </p>
            <div style={{ position: "relative", zIndex: 9 }}>
              <img
                src="https://cdn.blackincae.com/D57-vitality-box-l-otto.png"
                alt=""
                className="object-contain w-[95%]"
              />
            </div>

            <div className="main-container mx-auto text-center mx-6">
              <div className="relative -mt-6">
                <div
                  className="flex justify-center items-center rounded-b-[8px] mx-auto max-w-3xl bg-white overflow-hidden"
                  style={{ boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)" }}
                >
                  <div className="flex justify-center items-center">
                    <div className="flex justify-center items-center pt-12 flex-col">
                      <div className="max-w-4xl w-full md:px-8 px-4 text-start">
                        <div>
                          <p className="mb-8 text-[#233751] text-center font-bold md:text-[32px] text-[30px] bold-font">
                            What Is The Vitality Box?
                          </p>
                          <div className="flex flex-col md:flex-row">
                            <div className="w-full pr-4 text-[20px] font-normal">
                              <p className="mb-4 text-[#000000] leading-[24px]">
                                The Vitality Box is a carefully crafted
                                collection of four amazing and powerful health
                                formulations. They’re custom-designed to do far
                                more than just keep your airways clear.
                              </p>

                              <p className="mb-4 text-[#000000] leading-[24px]">
                                The Vitality Box works in perfect harmony with
                                Lung Renew® to supercharge your vitality to new
                                heights.
                              </p>
                            </div>
                          </div>

                          <div className="md:px-2 px-2 py-4 mx-auto md:max-w-xl max-w-full">
                            <div className="flex items-center space-x-2 border-t py-4 border-t-gray-400">
                              <div className="flex-shrink-0">
                                <img
                                  src={chbottle}
                                  alt="Logo 1"
                                  className="w-10 h-10"
                                />
                              </div>
                              <div className="">
                                <p className="text-[#282828] font-bold text-[20px] bold-font">
                                  Based on multiple breakthrough scientific
                                  studies...
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2 border-t py-4 border-t-gray-400">
                              <div className="flex-shrink-0">
                                <img
                                  src={lungslogo}
                                  alt="Logo 1"
                                  className="w-10 h-10"
                                />
                              </div>
                              <div className="">
                                <p className="text-[#282828] font-bold text-[20px] bold-font">
                                  These formulations help bulletproof your lung
                                  health… 
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-2 border-t py-4 border-t-gray-400">
                              <div className="flex-shrink-0">
                                <img
                                  src={boostimmune}
                                  alt="Logo 1"
                                  className="w-10 h-10"
                                />
                              </div>
                              <div className="">
                                <p className="text-[#282828] font-bold text-[20px] bold-font">
                                  Boost your immune system… 
                                </p>
                              </div>
                            </div>

                            <div className="flex items-center space-x-2 border-t py-4 border-t-gray-400">
                              <div className="flex-shrink-0">
                                <img
                                  src={bones}
                                  alt="Logo 1"
                                  className="w-10 h-10"
                                />
                              </div>
                              <div className="">
                                <p className="text-[#282828] font-bold text-[20px] bold-font">
                                  Strengthen your skin and bone health… 
                                </p>
                              </div>
                            </div>

                            <div className="flex items-center space-x-2 border-t border-b py-4 border-t-gray-400 border-b-gray-400">
                              <div className="flex-shrink-0">
                                <img
                                  src={energy}
                                  alt="Logo 1"
                                  className="w-10 h-10"
                                />
                              </div>
                              <div className="">
                                <p className="text-[#282828] font-bold text-[20px] bold-font">
                                  And give you all day energy.
                                </p>
                              </div>
                            </div>
                          </div>

                          <p className="mb-4 text-[#B91111] font-bold text-center text-[32px] bold-font">
                            That way, you can lead the life you WANT to live -
                            without anything holding you back.
                          </p>

                          <div className="flex justify-center items-center">
                            <div className="flex justify-center items-center md:px-4 px-0 py-6">
                              <div className="max-w-4xl w-full">
                                <div
                                  className="bg-[#EFF6FF] px-6 py-6 rounded-lg shadow-md flex flex-col md:flex-row relative"
                                  style={{
                                    boxShadow:
                                      "0px 1px 4px 0px rgba(0, 0, 0, 0.15)",
                                  }}
                                >
                                  <div className="w-full pr-4 space-y-4 text-gray-800 text-start text-[20px]">
                                    <p>
                                      All because the Vitality Box gives your
                                      body what it craves - at the cellular
                                      level.
                                    </p>
                                    <p className="underline font-bold text-[20px] italic bold-font">
                                      And for TODAY ONLY, you can get this
                                      powerful Vitality Box for FREE.
                                    </p>

                                    <p>You read that right.</p>
                                    <p className="underline font-bold text-[20px] bold-font">
                                      I’m literally giving it away.
                                    </p>

                                    <p>
                                      I’ve created this amazing special offer
                                      simply because you’re part of the family
                                      now.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#233751] text-white p-3 flex items-center flex-col w-full">
                        <h2 className="md:text-[21px] text-[24px] md:px-0 px-4 font-bold">
                          And it’s why 87% of customers jump on the chance to
                          get this Vitality Box for FREE.
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-center flex-col md:flex-row justify-center md:py-8 p-4 mx-auto max-w-3xl">
                  <div className="pr-4">
                    <img
                      src={formulations}
                      alt="FOUR POWERFUL FORMULATIONS"
                      className="w-[196px] h-[192px] spin-slow"
                    />
                  </div>

                  <div className="w-full leading-[34px]">
                    <p className="text-[#233751] md:text-start text-center md:text-[32px] text-[22px]">
                      So, first off, here are the <br />
                      <span className="font-bold md:text-[32px] text-[22px] bold-font italic">
                        FOUR POWERFUL FORMULATIONS
                      </span>
                      <br />
                      inside this premium subscription box… 
                    </p>
                  </div>
                </div>
                <div className="w-full mb-10">
                  <span className="mw10gift-highlight-yellow italic bold-font">
                    PLUS - how to get it all
                    <span className="underline"> FREE </span> Today!
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

  )
}

export default VitalityBoxx